import { render } from "./VideoPreview.vue?vue&type=template&id=6f5469ec"
import script from "./VideoPreview.vue?vue&type=script&lang=ts"
export * from "./VideoPreview.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./VideoPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script